var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import ScrollspyNav from 'react-scrollspy-nav';
import styles from './css/nav.module.css';
var About = /** @class */ (function (_super) {
    __extends(About, _super);
    function About(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = function (e) {
            console.log(e.target.checked ? 'on' : 'off');
            _this.setState({ menuToggle: e.target.checked });
        };
        _this.toggleOff = function () {
            _this.setState({ menuToggle: false });
        };
        _this.state = { menuToggle: false };
        return _this;
    }
    About.prototype.render = function () {
        return (React.createElement(ScrollspyNav, { scrollTargetIds: ['1', '2', '3', '4', '5'], activeNavClass: styles.active, offset: 2, headerBackground: "false" },
            React.createElement("nav", { className: styles.mainnav },
                React.createElement("nav", { className: styles.wrapper },
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("a", { className: styles.active, onClick: this.toggleOff, href: "#1" }, "Installation Service")),
                        React.createElement("li", null,
                            React.createElement("a", { className: styles.active, onClick: this.toggleOff, href: "#2" }, "About InstallerNet")),
                        React.createElement("li", null,
                            React.createElement("a", { className: styles.active, onClick: this.toggleOff, href: "#3" }, "Quality Installation")),
                        React.createElement("li", null,
                            React.createElement("a", { className: styles.active, onClick: this.toggleOff, href: "#4" }, "FAQs")),
                        React.createElement("li", null,
                            React.createElement("a", { className: styles.active, onClick: this.toggleOff, href: "#5" }, "Your Install")))))));
    };
    return About;
}(Component));
export default About;
